"use client";

import Lottie from "lottie-react";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "@/i18n/client";
import loading from "@/public/lotties/loading.json";
import { getSupportedLanguage } from "@/utils/language";
import enTranslations from "./locales/en.json";
import esTranslations from "./locales/es.json";
import ptTranslations from "./locales/pt.json";

// Cargar traducciones manualmente
const translations = {
  es: esTranslations,
  en: enTranslations,
  pt: ptTranslations,
};

function WaitScreenContent() {
  const { i18n } = useTranslation("translation");

  // Obtener el idioma actual
  const currentLang = getSupportedLanguage(i18n.resolvedLanguage);
  const trans = translations[currentLang as keyof typeof translations];

  return (
    <>
      <div className="w-[80px] h-[42px] mb-9">
        <Lottie animationData={loading} loop={true} />
      </div>
      <section className="space-y-2">
        <h3>
          <Typography className="text-primary-700" variant="heading 3">
            {trans.header}
          </Typography>
        </h3>
        <p>
          <Typography className="text-neutral-600" variant="body 2">
            {trans.body}
          </Typography>
        </p>
      </section>
    </>
  );
}

export default WaitScreenContent;
